module.exports = __webpack_public_path__ + "static/media/29.39a40c1f.svg";